import { VirtualBackgroundItem } from 'features/virtual-backgrounds/types';

export const BLUR_VALUE_MAP: Record<string, string> = {
  balanced: '0.4',
  strong: '0.8',
};

export const BLUR_REVERSE_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(BLUR_VALUE_MAP).map(([k, v]) => [v, k])
);

/**
 * Inbound adapter for the backgrounds an integrator declares in roomSettings, which document
 * blur as 'balanced' | 'strong' while the engine takes a numeric strength.
 */
export function adaptBlurBackgrounds(items: VirtualBackgroundItem[]): VirtualBackgroundItem[] {
  return items.map((item) =>
    item.type === 'blur' && BLUR_VALUE_MAP[item.value]
      ? { ...item, value: BLUR_VALUE_MAP[item.value] }
      : item
  );
}

/**
 * Inbound adapter: translates legacy SDK blur strings to internal numeric values.
 * Called before validateVBOptionsSaga in onConfigureVBCommandSaga.
 */
export function adaptVBOptions<T extends Record<string, unknown>>(options: T): T {
  if (typeof options.blur !== 'string') {
    return options;
  }
  const numericValue = BLUR_VALUE_MAP[options.blur];
  return numericValue ? { ...options, blur: numericValue } : options;
}
